var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loadingFlow)?_c('vca-loading'):_vm._e(),_c('notifications',{staticClass:"custom-notification"}),_c('TopNavigation',{staticClass:"desktop-view"}),_c('MobileNavigation',{staticClass:"mobile-view"}),_c('router-view',{attrs:{"id":"app-content"}}),_c('Footer',{attrs:{"id":"app-footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }